import { Chicken } from '../types/Chicken';

export const ChickenPredictionItem = ({chicken, image_url, user_id, feature_image_url}: {chicken: Chicken, image_url: string, user_id: string, feature_image_url: string}) => {
	const { simple } = chicken.attributes;

  return (
    <>
      <div className="card lg:card-side bg-base-100 shadow-sm mb-15">
        <figure>
          <img src={feature_image_url} className="max-h-[400px]" alt={ "Rooster named " + simple.name } />
        </figure>
        <div className="card-body text-black text-left">
            <h2 className="card-title mb-2">Rooster found!</h2>
            <div className="font-normal">
                This is <p className="font-bold inline capitalize hover:text-gray-400"><a href={ "/chickens/show/" + simple.value }>{ simple.name }</a></p>!
                We are certain this is him with a score of <p className="font-bold inline">{ (simple.score*100).toFixed(2) }%</p>.
            </div>
        </div>
      </div>
    </>
  );
};

export default ChickenPredictionItem;
